import {
  CloseOutlined,
  CloudUploadOutlined,
  FileExcelOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  CommandBar,
  MessageBar,
  MessageBarType,
  Pivot,
  PivotItem,
  PivotLinkSize,
  Link,
  ProgressIndicator,
} from "@fluentui/react";
import {
  Button,
  DatePicker,
  Space,
  Form,
  Tooltip,
  Layout,
  Input,
  Radio,
  notification,
  message,
  Drawer,
  Badge,
} from "antd";
import Dragger from "antd/lib/upload/Dragger";
import React, { createContext, useContext, useState } from "react";
import moment from "moment";
import { Eye, Save, X } from "react-feather";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { getPickerDate, toAntPickerDate } from "../../../Utility/modules/datePicker";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
import { observer } from "mobx-react-lite";

import { ENV } from "../../../Infrastructure/EnvironmentConfig";
import { QuaiboErrorLogs } from "./QuaiboErrorLogs";
import { QuaiboManualFormEntry } from "./QuaiboManualFormEntry";
import { QuaiboDailyProductionForm } from "./QuaiboDailyProductionForm";

const { Content, Sider } = Layout;
const _ = require("underscore");
const initData = {
  aseRiverExport: 0,
  aseRiverUptime: 0,
  bsw: 0,
  crudeInjectionGGF: 0,
  quaiboDailyProductionId: 0,
  flareGas: 0,
  forcadosExport: 0,
  forcadosUptime: 0,
  fuelGas: 0,
  gas: 0,
  gor: 0,
  condensate: 0,
  gasSuppliedToGasPlant: 0,
  netProduction: 0,
  oil: 0,
  productionDate: moment(new Date()).format("DD-MMM-YYYY"),
  stationDownHrs: 0,
  water: 0,
  stationAPI: 0,
  remarks: "",
  evacuationUptime: 0,
};

const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const QuaiboDailyProductionUpload = observer(() => {
  const [state, setState] = useState({
    excelData: [],
    selTab: "1",
  });
  // const [sheetName, setSheetName] = useState("");

  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const uploadprops = {
    name: "file",
    accept: ".xls,.xlsx",
    multiple: false,
    beforeUpload: (file, fileList) => {
      if (_.isEmpty(quaiboDailyProductionStore.sheetName)) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description:
            "input deck sheet name is required,enter the field production report sheetname",
        });

        return false;
      }
      return true;
    },
    headers: {
      method: "Post",
    },
    data: "newtemplate",
    action: `${ENV.API_ROOT}/QuaiboDailyProduction/ImportQuaiboDailyProductionExcel?data=${quaiboDailyProductionStore.sheetName}`,

    onChange(info) {
      try {
        const { status } = info.file;

        if (status === "done") {
          const { productionData, errors, wellPara } = info.file.response;
          console.log(wellPara);
          quaiboDailyProductionStore.wellparameters.clear();

          quaiboDailyProductionStore.initFormaData = productionData;
          if (wellPara) {
            wellPara.forEach((p) => {
              quaiboDailyProductionStore.wellparameters.set(
                p.quaiboDailyProductionWellId,
                p
              );
            });
          }

          if (errors.length) {
            quaiboDailyProductionStore.uploadErrors = errors;

            quaiboDailyProductionStore.selTab = "2";
          } else {
            quaiboDailyProductionStore.initFormaData = productionData;
            quaiboDailyProductionStore.uploadDate = moment(
              productionData.productionDate
            )._d;
            quaiboDailyProductionStore.uploadErrors = [];
            quaiboDailyProductionStore.selTab = "1";
          }
        } else if (status === "error") {
          quaiboDailyProductionStore.showUploadErrorMessage = true;
          message.error(`${info.file.name} file preview failed.`);
          notification.error({
            message: "SPARS Feedback",
            description: `${info.file.response}`,
          });
        }
      } catch (error) {
        message.error(`${info.file.name} file preview failed.`);
      }
    },
  };
  return (
    <Drawer
      title={
        <>
          <CloudUploadOutlined styel={{ color: "red" }} />{" "}
          <span>{`QUAIBO FIELD PRODUCTION UPLOAD for ${moment(
            quaiboDailyProductionStore.uploadDate
          ).format("DD-MMM-YYYY")}`}</span>
        </>
      }
      visible={quaiboDailyProductionStore.showQuaiboDailyProductionDialog}
      onClose={() => {
        quaiboDailyProductionStore.showQuaiboDailyProductionDialog = false;
      }}
      width={"80%"}
      destroyOnClose={true}
      drawerStyle={{ borderTop: "5px solid #2FA8CC" }}
    >
      <div className="ms-Grid" dir="ltr" style={{ padding: "10px" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm4">
                  <Radio.Group
                    buttonStyle="solid"
                    value={quaiboDailyProductionStore.view}
                    onChange={({ target }) => {
                      quaiboDailyProductionStore.view = target.value;
                    }}
                  >
                    <Radio.Button value="upload">
                      Input Deck Upload
                    </Radio.Button>
                    <Radio.Button value="manual">
                      Production Data Entry
                    </Radio.Button>
                  </Radio.Group>
                </div>

                <div className="ms-Grid-col ms-sm4">
                  {quaiboDailyProductionStore.view === "upload" && (
                    <>
                      <div style={{ textAlign: "center" }}>
                        {" "}
                        <span style={{ color: "red" }}>
                          Don't have QUAIBO Daily Field Production Input Deck?
                        </span>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <Tooltip title="click to download  QUAIBO Daily Field Production  input deck for Quaibo Asset operations.">
                          <Link
                            underline={true}
                            style={{ textDecoration: "underline" }}
                            onClick={async () => {
                              try {
                                await quaiboDailyProductionStore.DownlaodDailyProductionTemplate();
                              } catch (error) {
                                notification.error({
                                  message: "SPARS Feedback",
                                  description: error.message,
                                });
                              }
                            }}
                          >
                            Download standard QUAIBO Daily Field Input Deck
                          </Link>
                        </Tooltip>
                      </div>
                    </>
                  )}
                </div>

                <div
                  className="ms-Grid-col ms-sm4"
                  style={{ textAlign: "right" }}
                >
                  <Space>
                    <Button
                      type="primary"
                      disabled={
                        !quaiboDailyProductionStore.isValidProductionData
                      }
                      icon={<Save className="bicon" />}
                      onClick={async () => {
                        try {
                          const retVal =
                            await quaiboDailyProductionStore.saveDailyProduction(
                              quaiboDailyProductionStore.initFormaData
                            );
                          if (retVal.success) {
                            quaiboDailyProductionStore.showQuaiboDailyProductionDialog = false;
                            let prod = retVal.production;
                            message.success(
                              `Quaibo Field Production Data upload for ${moment(
                                quaiboDailyProductionStore.uploadDate
                              ).format("dddd DD-MMM-YYYY")} was sucessfull`
                            );
                            quaiboDailyProductionStore.dailyProductions.set(
                              prod.quaiboDailyProductionId,
                              {
                                ...prod,
                                modifiedProductionDate: moment(
                                  prod.productionDate
                                ).format("ddd DD-MMM-YYYY"),
                                strippedRemarks: prod.remarks
                                  ? prod.remarks.replace(/(<([^>]+)>)/gi, " ")
                                  : null,
                              }
                            );
                          } else {
                            notification.error({
                              message: "SPARS Feedback",
                              description: retVal.message,
                            });
                          }
                        } catch (error) {
                          notification.error({
                            message: "SPARS Feedback",
                            description: error.message,
                          });
                        }
                      }}
                    >
                      Save
                    </Button>
                  </Space>
                </div>
              </div>
            </div>
          </div>
        </div>
        {quaiboDailyProductionStore.isDownloadingTemplate && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProgressIndicator
                description="downloading template,please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}
        {quaiboDailyProductionStore.isSaving && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProgressIndicator
                description="saving production data,please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}

        {quaiboDailyProductionStore.showUploadErrorMessage && (
          <MessageBar
            type={MessageBarType.blocked}
            styles={{ root: { backgroundColor: "rgb(253, 231, 233)" } }}
            truncated={true}
            isMultiline={false}
          >
            This error may occur due to alteration of the standard upload
            template like inserting rows and columns in the upload workbook,
            thereby distorting the cell adresses, this can be resolved by
            mapping the cell adresses correctly.
            <Link href="/main/administration/settings">Go to Mapping.</Link>
          </MessageBar>
        )}
      </div>

      {quaiboDailyProductionStore.view === "upload" ? (
        <Layout style={{ background: "#fff" }}>
          <Content style={{ background: "#fff" }}>
            <Layout>
              <Sider
                width={300}
                style={{
                  background: "#F0F2F5",
                  height: "100vh",
                  padding: "10px",
                }}
              >
                <div className="ms-Grid" dir="ltr">
                  <div
                    className="ms-Grid-row"
                    style={{ background: "#F0F2F5" }}
                  >
                    <div className="ms-Grid-col ms-sm12">
                      {" "}
                      <SubPageHeaderTitle title="Browse Pane" />
                    </div>
                  </div>
                  <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                      <Form layout="vertical">
                        <Form.Item
                          label={
                            <span style={{ color: "red" }}>
                              Production Date*
                            </span>
                          }
                        >
                          <Tooltip title="Quaibo field production date">
                            <DatePicker
                              value={toAntPickerDate(quaiboDailyProductionStore?.uploadDate)}
                              onChange={(date, dateString) => {
                                console.log(date, dateString);
                                if (date) {
                                  quaiboDailyProductionStore.uploadDate =
                                    getPickerDate(date);
                                  let dateVal = date.format(
                                    "YYYY-MM-DDT00:00:00.000Z"
                                  );

                                  quaiboDailyProductionStore.initFormaData.productionDate =
                                    dateVal;
                                }
                              }}
                              style={{ width: "100%" }}
                              defaultValue={toAntPickerDate(new Date())}
                              format={"DD-MMM-YYYY"}
                              locale={"en_US"}
                            />
                          </Tooltip>
                        </Form.Item>

                        <Form.Item
                          label={
                            <span style={{ color: "red" }}>
                              Input Deck WorkSheet *
                            </span>
                          }
                        >
                          <Tooltip title="enter the sheetname where the quaibo field production is located in the browsed workbook e.g Main ">
                            <Input
                              placeholder="Worksheet Name"
                              value={quaiboDailyProductionStore.sheetName}
                              defaultValue="Main"
                              onChange={({ target }) => {
                                quaiboDailyProductionStore.sheetName =
                                  target.value;
                              }}
                            />
                          </Tooltip>
                        </Form.Item>
                        <Form.Item>
                          <Dragger
                            style={{
                              width: "100%",
                              backgroundColor: "transparent",
                            }}
                            multiple={false}
                            {...uploadprops}
                          >
                            <p className="ant-upload-drag-icon">
                              <FileExcelOutlined style={{ color: "#68D391" }} />
                            </p>
                            <p className="ant-upload-text">
                              Browse for Quaibo Field Production Input Deck
                            </p>
                          </Dragger>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </Sider>
              <Content style={{ background: "#F0F2F5" }}>
                <div
                  className="ms-Grid"
                  dir="ltr"
                  style={{ background: "white" }}
                >
                  <Pivot
                    linkSize={PivotLinkSize.normal}
                    selectedKey={quaiboDailyProductionStore.selTab}
                    onLinkClick={(item, ev) => {
                      quaiboDailyProductionStore.selTab = item.props.itemKey;
                    }}
                  >
                    <PivotItem
                      headerText="Field Production and Evacuation Data"
                      itemKey="1"
                    >
                      <div
                        className="ms-Grid-row"
                        style={{ background: "white" }}
                      >
                        <MessageBar messageBarType={MessageBarType.info}>
                          <div className="ms-Grid" dir="ltr">
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">
                                {`QUA IBOE (OML 13) DAILY PRODUCTION AND
                                EVACUATION @ ${moment(
                                  quaiboDailyProductionStore.uploadDate
                                ).format("DD/MM/YYYY")}`}
                              </div>
                            </div>
                          </div>
                        </MessageBar>
                        <CommandBar
                          items={[
                            {
                              key: "clear",
                              text: "Clear Entries",
                              onRenderIcon: () => <X />,
                              onClick: async () => {
                                quaiboDailyProductionStore.initFormaData =
                                  initData;
                                quaiboDailyProductionStore.uploadDate = moment(
                                  new Date()
                                );
                                await quaiboDailyProductionStore.loadInitialWellParameters();
                                quaiboDailyProductionStore.showNaocDailyProductionDialog = true;
                              },
                            },
                          ]}
                        />
                      </div>

                      <QuaiboDailyProductionForm />
                    </PivotItem>
                    <PivotItem
                      headerText="Deck Upload Data Validation"
                      itemKey="2"
                      onRenderItemLink={(link, defaultRenderer) => (
                        <span>
                          <InfoCircleOutlined style={{ color: "red" }} />{" "}
                          {defaultRenderer(link)}{" "}
                          <Badge
                            count={
                              quaiboDailyProductionStore.uploadErrors.length
                            }
                          />
                        </span>
                      )}
                    >
                      <QuaiboErrorLogs />
                    </PivotItem>
                  </Pivot>
                </div>
              </Content>
            </Layout>
          </Content>
        </Layout>
      ) : (
        <QuaiboManualFormEntry />
      )}
    </Drawer>
  );
});

